import IconController from '../../containers/iconController';
import './css/chartTitle.css';
import React from 'react';

const ChartTitle = ({chartTitle, chartDescription}) => {
  return (
    <div className='ReportTitle'>
      <h2>{chartTitle}</h2>
      {chartDescription && (
        <div className='reportDescription'>
          <IconController iconType="InfoOutlinedIcon" fontSize='large'/>
          <div className='hoverText'>
            {chartDescription.map(item => {
              return (<p>{item}</p>)
            })}
          </div>
        </div>
      )}
    </div>
  )
}

export default ChartTitle